import { Query } from '@common/Query/Query'
import { URL } from '@common/URL/URL'

import { is } from '@common/is/is'

// eslint-disable-next-line custom/no-restricted-imports -- Itt megengedett.
import promiseAjax from '@common/ajax/promise/ajax'

import type { IQueryParams, TRequestMethod } from '../definitions'

interface IQuery {
  t: string | undefined
  s: string | undefined
  target?: 'dev'
}

/**
 * Egyszerű Promise-alapú ajax küldése szerver felé.
 * Önmagában a vakvilágban nem használható, csak a 'calls' mappában található függvényekhez.
 * @param url    - A kérés URL-je.
 * @param data   - Opcionális adat.
 * @param method - Opcionális metódus.
 */
export default async function ajax<T, K extends TAnyObject | undefined = undefined> (
  url: string,
  data?: K,
  method: TRequestMethod = 'GET'
): Promise<T | null> {
  const contentType = is.defined(data) ? 'application/json' : undefined

  const query = Query.decode(window.location.search)

  /** Ez itt a JWT token, amit a Csillagsuli rak rá az indított appra, mint query paraméter. */
  const t = query.t as string | undefined

  /** Ez itt a CORP-os, belépett felhasználó stoc-a, ha az adminon keresztül indítunk appot / modult. */
  const s = query.stoc as string | undefined

  /**
   * A targettel dev.csillagsuli.hu problémát oldunk meg, hogy megmondjuk a backendnek, hogy
   * melyik gateway-el akarunk kommunikálni.
   * Minden esetben az éles gateway-nek megy alapból a kérés, de ha van target=dev, akkor forwardolva lesz
   * a dev gateway-nek.
   */
  const target: { target?: 'dev' } = is.string(query.target) && query.target === 'dev'
    ? { target: 'dev' }
    : {}

  const finalQuery: IQueryParams = {
    t,
    s,
    ...target
  } satisfies IQuery

  const finalUrl = URL.make(url, finalQuery)

  try {
    const response = await promiseAjax(finalUrl, {
      data,
      method,
      contentType
    })

    // eslint-disable-next-line no-restricted-globals -- Ide ne húzzuk be a saját JSON-t.
    const res = JSON.parse(response?.responseText ?? '{}')

    return res
  }
  catch {
    // Nem kell ide semmi.
  }

  return null
}
